import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  NFTProfRequirement,
  NFTProfBlockchain,
  NFTSmartContact,
  NFTProfFrontend,
  NFTProfGateway,
  NFTProfLaunch,
} from "../../../app-constants";

function Nftproficient() {
  return (
    <section className="nft_proficient p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={9}
            lg={8}
            xl={7}
            xxl={7}
            className="m-auto text-center"
          >
            <h2>Our Proficient Approach for NFT Development</h2>
            <p>
              We build on vast experience in blockchain technology services,
              which allows us to offer a full range of NFT development
              solutions. We offer organized and personalized solutions that are
              designed with your business objectives and goals in mind. Every
              process from the initial conceptualization to the launch is
              managed and controlled through a solid implementation process to
              give the best results in NFT development.
            </p>
          </Col>
        </Row>
        <Row className="mt-sm-3 mt-md-5">
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <Row>
              <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                <div className="nft_prof_box">
                  <div className="nft_prof_svg">{NFTProfRequirement}</div>
                  <div className="nft_prof_content">
                    <h5>Requirement Analysis & Planning</h5>
                    <p>
                      We conduct a thorough analysis of your business
                      requirements and plan the NFT development roadmap,
                      ensuring alignment with your strategic goals and technical
                      specifications.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                <div className="nft_prof_box">
                  <div className="nft_prof_svg">{NFTProfBlockchain}</div>
                  <div className="nft_prof_content">
                    <h5>Blockchain Selection</h5>
                    <p>
                      Based on your project needs, we choose the most suitable
                      blockchain platform, such as Ethereum, Binance Smart
                      Chain, or Flow, to ensure optimal performance and
                      scalability.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                <div className="nft_prof_box">
                  <div className="nft_prof_svg">{NFTSmartContact}</div>
                  <div className="nft_prof_content">
                    <h5>Smart Contract Development</h5>
                    <p>
                      Our team designs and develops secure and efficient smart
                      contracts, leveraging industry-standard libraries and best
                      practices to automate NFT transactions and ensure
                      integrity.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                <div className="nft_prof_box">
                  <div className="nft_prof_svg">{NFTProfFrontend}</div>
                  <div className="nft_prof_content">
                    <h5>Front-End and Back-End Development</h5>
                    <p>
                      We create intuitive front-end interfaces and robust
                      back-end systems to support NFT transactions, ensuring a
                      seamless user experience and reliable data management.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                <div className="nft_prof_box">
                  <div className="nft_prof_svg">{NFTProfGateway}</div>
                  <div className="nft_prof_content">
                    <h5>Integration with Payment Gateways</h5>
                    <p>
                      We integrate multiple payment options, including digital
                      wallets and credit cards, to facilitate secure and
                      convenient NFT transactions for users.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                <div className="nft_prof_box">
                  <div className="nft_prof_svg">{NFTProfLaunch}</div>
                  <div className="nft_prof_content">
                    <h5>Testing and Deployment</h5>
                    <p>
                      We integrate multiple payment options, including digital
                      wallets and credit cards, to facilitate secure and
                      convenient NFT transactions for users.
                    </p>
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Nftproficient;
